<template>
  <div>
    <el-row :gutter="20">
      <template v-for="(data,i) in 6">
        <el-col :span="4">
          <div
            class="grid-content bg-purple box"
            @mouseover="mouseLeave(i)"
            @mouseleave="mouseLeave2(i)"
            
          >
            <img src="../assets/logo.png" />
            <div class="logoMsg" style="position: absolute">
              <p>vue的图标</p>
              使用次数：2次
             
            </div>
            <div class="btnGroup"  ref="datalist">
              <el-button icon="el-icon-edit" >编辑</el-button>
              <el-button icon="el-icon-delete" >删除</el-button>
               
            </div>
          </div>
        </el-col>
      </template>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: "",
    };
  },
  methods: {
    mouseLeave(i) {
      this.active = "";
      // console.log(i);
      // console.log(this.$refs.datalist);
      // console.log(this.$refs.datalist[i]);
      var acps = this.$refs.datalist[i];

      acps.style.display = "block";
      // this.$refs.style.display = "none"
    },
    mouseLeave2(i) {
      var acps = this.$refs.datalist[i];
      acps.style.display = "none";
    },
  },
};
</script>
<style scoped>
.box {
  height: 180px;
  width: 180px;

}
.box > img {
  height: 80px;
  width: auto;
  /* position: relative; */
  margin: auto;
}
.btnGroup {
  position: absolute;
  background: rgba(245, 247, 250, 1);
  width: 180px;
  height: 80px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  display: none;
  z-index: 2;
}
.logoMsg{
  margin: auto;
width: 180px;
}
</style>
<style>
.el-row {
  margin-bottom: 20px !important;
}
.el-row:last-child {
  margin-bottom: +20px !important;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  /* background: #99a9bf; */
}
.bg-purple {
  /* background: #d3dce6; */
}
.bg-purple-light {
  /* background: #e5e9f2; */
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
  /* border: 1px solid #DCDFE6; */
}
.row-bg {
  padding: 10px 0;
  /* background-color: #f9fafc; */
}
.btnGroup>.el-button{
  width: 100% !important;
  background:transparent;
  border-left: none;
  border-top: none;
  border-right: none;
  margin: 0px;
}
.btnGroup>.el-button:last-of-type{

  border: none;
 
}
</style>